import { Box, Typography, Button } from '@mui/material';
import { Lock } from '@mui/icons-material';

/**
 * Phase 10g: EdgePlay is a player surface, never an open app. Every route
 * must be reached via an EdgeHub-issued JWT in the launch URL — either from
 * the /academy catalog (Academy seat door) or from an assessment magic link
 * (assessment door). If a user lands on EdgePlay without that token,
 * everything is locked and we send them to EdgeHub to authenticate.
 *
 * The backend session-creation endpoint also enforces this independently
 * via the Phase 10g entitlement gate, so a hand-crafted POST cannot
 * bypass the frontend lock. This component just keeps the UX honest.
 */
export default function AuthRequired() {
  const edgehubUrl = (import.meta.env.VITE_EDGEHUB_URL as string | undefined) || 'http://localhost:3001';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        px: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: 520,
          textAlign: 'center',
          p: 5,
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: 1,
          borderColor: 'divider',
        }}
      >
        <Lock sx={{ fontSize: 48, color: 'warning.main', mb: 2 }} />
        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 1.5 }}>
          Sign in to launch a scenario
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          EdgePlay is the simulation player. To start a scenario, sign in
          at the Edge Hub and launch from your Edge Academy catalog, or use
          the magic link from your assessment invitation email.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          href={edgehubUrl}
        >
          Go to Edge Hub
        </Button>
      </Box>
    </Box>
  );
}
